import styled from "styled-components";

export const Back = styled.img`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  width: 100%;

  @media screen and (max-width: 960px) {
    content: url("/image/lp/kaleido/bg/long/bg-sp.png");
  }
  @media screen and (min-width: 961px) {
    content: url("/image/lp/kaleido/bg/long/bg-pc-compression.png");
  }

  @media screen and (max-width: 260px) {
    top: 618vw;
    height: 580vw;
  }
  @media screen and (min-width: 261px) {
    top: 618vw;
    height: 575vw;
  }
  @media screen and (min-width: 271px) {
    top: 618vw;
    height: 560vw;
  }
  @media screen and (min-width: 281px) {
    top: 618vw;
    height: 575vw;
  }
  @media screen and (min-width: 291px) {
    top: 618vw;
    height: 560vw;
  }
  @media screen and (min-width: 301px) {
    top: 618vw;
    height: 545vw;
  }
  @media screen and (min-width: 311px) {
    top: 618vw;
    height: 530vw;
  }
  @media screen and (min-width: 331px) {
    top: 618vw;
    height: 510vw;
  }
  @media screen and (min-width: 341px) {
    top: 613vw;
    height: 510vw;
  }
  @media screen and (min-width: 361px) {
    top: 613vw;
    height: 520vw;
  }
  @media screen and (min-width: 376px) {
    top: 611vw;
    height: 505vw;
  }
  @media screen and (min-width: 391px) {
    top: 610vw;
    height: 495vw;
  }
  @media screen and (min-width: 411px) {
    top: 610vw;
    height: 480vw;
  }
  @media screen and (min-width: 421px) {
    top: 608vw;
    height: 475vw;
  }
  @media screen and (min-width: 451px) {
    top: 606vw;
    height: 460vw;
  }
  @media screen and (min-width: 461px) {
    top: 623vw;
    height: 453vw;
  }
  @media screen and (min-width: 481px) {
    top: 620vw;
    height: 445vw;
  }
  @media screen and (min-width: 501px) {
    top: 620vw;
    height: 455vw;
  }
  @media screen and (min-width: 511px) {
    top: 618vw;
    height: 455vw;
  }
  @media screen and (min-width: 541px) {
    top: 616vw;
    height: 440vw;
  }
  @media screen and (min-width: 571px) {
    top: 614vw;
    height: 428vw;
  }
  @media screen and (min-width: 601px) {
    top: 612vw;
    height: 418vw;
  }
  @media screen and (min-width: 631px) {
    top: 610vw;
    height: 410vw;
  }
  @media screen and (min-width: 661px) {
    top: 615vw;
    height: 398vw;
  }
  @media screen and (min-width: 691px) {
    top: 613vw;
    height: 392vw;
  }
  @media screen and (min-width: 721px) {
    top: 612vw;
    height: 385vw;
  }
  @media screen and (min-width: 751px) {
    top: 611vw;
    height: 375vw;
  }
  @media screen and (min-width: 781px) {
    top: 610vw;
    height: 370vw;
  }
  @media screen and (min-width: 811px) {
    top: 608vw;
    height: 365vw;
  }
  @media screen and (min-width: 841px) {
    top: 607vw;
    height: 357vw;
  }
  @media screen and (min-width: 871px) {
    top: 605vw;
    height: 355vw;
  }
  @media screen and (min-width: 901px) {
    top: 603vw;
    height: 348vw;
  }
  @media screen and (min-width: 931px) {
    top: 600vw;
    height: 340vw;
  }
  
  @media screen and (min-width: 961px) {
    top: 2950px;
    height: 3450px;
  }
  @media screen and (min-width: 1001px) {
    top: 3050px;
    height: 3520px;
  }
  @media screen and (min-width: 1051px) {
    top: 3100px;
    height: 3520px;
  }
  @media screen and (min-width: 1101px) {
    top: 3150px;
    height: 3500px;
  }
  @media screen and (min-width: 1111px) {
    top: 3200px;
    height: 3480px;
  }
  @media screen and (min-width: 1151px) {
    top: 3220px;
    height: 3500px;
  }
  @media screen and (min-width: 1201px) {
    top: 3250px;
    height: 3500px;
  }
  @media screen and (min-width: 1251px) {
    top: 3250px;
    height: 3500px;
  }
  @media screen and (min-width: 1281px) {
    top: 3250px;
    height: 3760px;
  }
  @media screen and (min-width: 1351px) {
    top: 3450px;
    height: 3800px;
  }
  @media screen and (min-width: 1451px) {
    top: 3520px;
    height: 3800px;
  }
  @media screen and (min-width: 1501px) {
    top: 3580px;
    height: 3850px;
  }
  @media screen and (min-width: 1551px) {
    top: 3620px;
    height: 3850px;
  }
  @media screen and (min-width: 1601px) {
    top: 3650px;
    height: 3850px;
  }
  @media screen and (min-width: 1701px) {
    top: 3700px;
    height: 3850px;
  }
  @media screen and (min-width: 1801px) {
    top: 3750px;
    height: 3850px;
  }
  @media screen and (min-width: 1901px) {
    top: 3800px;
    height: 3900px;
  }
  @media screen and (min-width: 2001px) {
    top: 3880px;
    height: 3900px;
  }
  @media screen and (min-width: 2101px) {
    top: 3950px;
    height: 3900px;
  }
  @media screen and (min-width: 2201px) {
    top: 4050px;
    height: 3820px;
  }
  @media screen and (min-width: 2301px) {
    top: 4120px;
    height: 3800px;
  }

  @media screen and (min-width: 2401px) {
    width: 2400px;
    height: 3900px;
  }

  @media screen and (min-width: 2401px) {
    top: 4200px;
  }
  @media screen and (min-width: 2501px) {
    top: 4250px;
  }
  @media screen and (min-width: 2601px) {
    top: 4300px;
  }
  @media screen and (min-width: 2701px) {
    top: 4380px;
  }
  @media screen and (min-width: 2801px) {
    top: 4450px;
  }
  @media screen and (min-width: 2901px) {
    top: 4500px;
  }
  @media screen and (min-width: 3001px) {
    top: 4580px;
  }
  @media screen and (min-width: 3101px) {
    top: 4650px;
  }
  @media screen and (min-width: 3201px) {
    top: 4700px;
  }
  @media screen and (min-width: 3301px) {
    top: 4750px;
  }
  @media screen and (min-width: 3401px) {
    top: 4830px;
  }
  @media screen and (min-width: 3501px) {
    top: 4900px;
  }
  @media screen and (min-width: 3601px) {
    top: 4950px;
  }
  @media screen and (min-width: 3701px) {
    top: 5020px;
  }
  @media screen and (min-width: 3801px) {
    top: 5100px;
  }
  @media screen and (min-width: 3901px) {
    top: 5150px;
  }
  @media screen and (min-width: 4001px) {
    top: 5200px;
  }
  @media screen and (min-width: 4201px) {
    top: 5350px;
  }
  @media screen and (min-width: 4401px) {
    top: 5480px;
  }
  @media screen and (min-width: 4601px) {
    top: 5600px;
  }
  @media screen and (min-width: 4801px) {
    top: 5720px;
  }
  @media screen and (min-width: 5001px) {
    top: 5850px;
  }
`;

export const Back2 = styled.img`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: -2;
  width: 100%;
  background-repeat: repeat-y;

  @media screen and (max-width: 960px) {
    content: url("/image/lp/kaleido/bg/long/bg-sp.png");
  }
  @media screen and (min-width: 961px) {
    content: url("/image/lp/kaleido/bg/long/bg-pc-bottom.png");
  }
  @media screen and (min-width: 1351px) {
    content: url("/image/lp/kaleido/bg/long/bg-pc-bottom3.png");
  }

  @media screen and (max-width: 260px) {
    top: 705vw;
    height: 620vw;
  }
  @media screen and (min-width: 261px) {
    top: 705vw;
    height: 610vw;
  }
  @media screen and (min-width: 271px) {
    top: 700vw;
    height: 580vw;
  }
  @media screen and (min-width: 281px) {
    top: 672vw;
    height: 610vw;
  }
  @media screen and (min-width: 291px) {
    top: 671vw;
    height: 590vw;
  }
  @media screen and (min-width: 301px) {
    top: 667vw;
    height: 575vw;
  }
  @media screen and (min-width: 311px) {
    top: 668vw;
    height: 560vw;
  }
  @media screen and (min-width: 331px) {
    top: 664vw;
    height: 545vw;
  }
  @media screen and (min-width: 341px) {
    top: 652vw;
    height: 540vw;
  }
  @media screen and (min-width: 351px) {
    top: 652vw;
    height: 540vw;
  }
  @media screen and (min-width: 361px) {
    top: 648vw;
    height: 545vw;
  }
  @media screen and (min-width: 376px) {
    top: 646vw;
    height: 530vw;
  }
  @media screen and (min-width: 391px) {
    top: 645vw;
    height: 520vw;
  }
  @media screen and (min-width: 401px) {
    top: 645vw;
    height: 525vw;
  }
  @media screen and (min-width: 411px) {
    top: 657vw;
    height: 505vw;
  }
  @media screen and (min-width: 421px) {
    top: 650vw;
    height: 500vw;
  }
  @media screen and (min-width: 431px) {
    top: 642vw;
    height: 500vw;
  }
  @media screen and (min-width: 441px) {
    top: 632vw;
    height: 495vw;
  }
  @media screen and (min-width: 451px) {
    top: 645vw;
    height: 480vw;
  }
  @media screen and (min-width: 461px) {
    top: 662vw;
    height: 475vw;
  }
  @media screen and (min-width: 471px) {
    top: 652vw;
    height: 473vw;
  }
  @media screen and (min-width: 481px) {
    top: 653vw;
    height: 465vw;
  }
  @media screen and (min-width: 491px) {
    top: 647vw;
    height: 465vw;
  }
  @media screen and (min-width: 501px) {
    top: 642vw;
    height: 475vw;
  }
  @media screen and (min-width: 511px) {
    top: 635vw;
    height: 475vw;
  }
  @media screen and (min-width: 541px) {
    top: 633vw;
    height: 457vw;
  }
  @media screen and (min-width: 571px) {
    top: 629vw;
    height: 445vw;
  }
  @media screen and (min-width: 591px) {
    top: 620vw;
    height: 444vw;
  }
  @media screen and (min-width: 601px) {
    top: 625vw;
    height: 434vw;
  }
  @media screen and (min-width: 631px) {
    top: 621vw;
    height: 425vw;
  }
  @media screen and (min-width: 661px) {
    top: 628vw;
    height: 412vw;
  }
  @media screen and (min-width: 691px) {
    top: 628vw;
    height: 405vw;
  }
  @media screen and (min-width: 721px) {
    top: 625vw;
    height: 398vw;
  }
  @media screen and (min-width: 751px) {
    top: 627vw;
    height: 386vw;
  }
  @media screen and (min-width: 781px) {
    top: 622vw;
    height: 382vw;
  }
  @media screen and (min-width: 811px) {
    top: 620vw;
    height: 376vw;
  }
  @media screen and (min-width: 841px) {
    top: 620vw;
    height: 368vw;
  }
  @media screen and (min-width: 871px) {
    top: 619vw;
    height: 366vw;
  }
  @media screen and (min-width: 901px) {
    top: 616vw;
    height: 358vw;
  }
  @media screen and (min-width: 931px) {
    top: 614vw;
    height: 350vw;
  }
  

  @media screen and (min-width: 961px) {
    height: 60vw;
  }

  @media screen and (min-width: 961px) {
    top: 6200px;
  }
  @media screen and (min-width: 1001px) {
    top: 6300px;
  }
  @media screen and (min-width: 1111px) {
    top: 6350px;
  }
  @media screen and (min-width: 1151px) {
    top: 6360px;
  }
  @media screen and (min-width: 1201px) {
    top: 6370px;
  }
  @media screen and (min-width: 1251px) {
    top: 6380px;
  }
  @media screen and (min-width: 1281px) {
    top: 6700px;
  }

  @media screen and (min-width: 1351px) {
    height: auto;
  }

  @media screen and (min-width: 1351px) {
    top: 7100px;
  }
  @media screen and (min-width: 1451px) {
    top: 7100px;
  }
  @media screen and (min-width: 1501px) {
    top: 7200px;
  }
  @media screen and (min-width: 1551px) {
    top: 7200px;
  }
  @media screen and (min-width: 1601px) {
    top: 7250px;
  }
  @media screen and (min-width: 1701px) {
    top: 7300px;
  }
  @media screen and (min-width: 1801px) {
    top: 7350px;
  }
  @media screen and (min-width: 1901px) {
    top: 7400px;
  }
  @media screen and (min-width: 2001px) {
    top: 7400px;
  }
  @media screen and (min-width: 2101px) {
    top: 7450px;
  }
  @media screen and (min-width: 2201px) {
    top: 7450px;
  }
  @media screen and (min-width: 2301px) {
    top: 7500px;
  }

  @media screen and (min-width: 2401px) {
    width: 2400px;
  }
  
  @media screen and (min-width: 2401px) {
    top: 7605px;
  }
  @media screen and (min-width: 2501px) {
    top: 7605px;
  }
  @media screen and (min-width: 2601px) {
    top: 7705px;
  }
  @media screen and (min-width: 2701px) {
    top: 7755px;
  }
  @media screen and (min-width: 2801px) {
    top: 7800px;
  }
  @media screen and (min-width: 2901px) {
    top: 7900px;
  }
  @media screen and (min-width: 3001px) {
    top: 7950px;
  }
  @media screen and (min-width: 3101px) {
    top: 8100px;
  }
  @media screen and (min-width: 3201px) {
    top: 8150px;
  }
  @media screen and (min-width: 3301px) {
    top: 8200px;
  }
  @media screen and (min-width: 3401px) {
    top: 8250px;
  }
  @media screen and (min-width: 3501px) {
    top: 8350px;
  }
  @media screen and (min-width: 3601px) {
    top: 8400px;
  }
  @media screen and (min-width: 3701px) {
    top: 8450px;
  }
  @media screen and (min-width: 3801px) {
    top: 8500px;
  }
  @media screen and (min-width: 3901px) {
    top: 8600px;
  }
  @media screen and (min-width: 4001px) {
    top: 8700px;
  }
  @media screen and (min-width: 4201px) {
    top: 8800px;
  }
  @media screen and (min-width: 4401px) {
    top: 8950px;
  }
  @media screen and (min-width: 4601px) {
    top: 9050px;
  }
  @media screen and (min-width: 4801px) {
    top: 9250px;
  }
  @media screen and (min-width: 5001px) {
    top: 9400px;
  }
`;
